import React from 'react'

const Spinner = props => {

    return (
        <>
            {
                props.container
                    ? <div className='spinner__container'>
                        <div className="spinner"></div>
                    </div>
                    : <div className="spinner"></div>
            }
        </>
    )
}

export default Spinner